import { useAuthRedirect } from '../hooks/useAuthRedirect';
import { useAppNavigation } from '@practium/features/navigation';
import { AuthLayout } from '../components/AuthLayout/AuthLayout';
import { AuthPromoPanel } from '../components/AuthPromoPanel/AuthPromoPanel';
import { LoginForm } from '../components/LoginForm/LoginForm';
import { BarChart } from '@mui/icons-material';
import styles from './LoginPage.module.css';

interface LoginPageProps {
	onSuccess: () => void;
	appContext?: 'admin' | 'client';
}

export const LoginPage = ({ onSuccess, appContext }: LoginPageProps) => {
	const { isLoading } = useAuthRedirect({ appContext });
	const { navigateToClientRegister } = useAppNavigation();

	if (isLoading) {
		return null;
	}

	return (
		<AuthLayout
			title="Login"
			subtitle={
				<>
					Não tem uma conta?{' '}
					<button
						className={styles.subtitleLink}
						onClick={navigateToClientRegister}
					>
						Crie aqui
					</button>
				</>
			}
			promoPanel={
				<AuthPromoPanel
					promoImageSrc="/images/login-promo-image.jpg"
					promoTitle="Alcance metas rápido"
					promoDescription="Utilize o Practium para fazer todo o controle fino da sua operação, atingindo suas metas para 2026"
					statsCard={{
						icon: <BarChart />,
						label: 'Faturamento',
						value: 'R$75 040',
					}}
					sectionHeading="Controle total da operação"
					sectionText="Tenha o controle total da sua operação na palma de suas mãos, acompanhando produção, custos, equipes e resultados em tempo real, tudo no Practium"
				/>
			}
		>
			<LoginForm onSuccess={onSuccess} />
		</AuthLayout>
	);
};
